import type { IClient, IProvider } from '../../utils/types';

export function transformAdminTableData(list: IClient[] | IProvider[]) {
  return list.map((client) => ({
    name: `${client.first_name} ${client.last_name}`,
    ...client,
  }));
}
